import { useState, useCallback, useEffect } from 'react';
import { getERPOracleRequestDetail } from '../../../../api/index';
import { useAuthToken } from '../../../../hooks/AuthHook';

/**
 * Hook for fetching Oracle sync request details
 * @param {string} country - Country code
 * @param {string|null} requestId - Request ID to fetch (null to skip fetching)
 */
export const useOracleRequestDetail = ({ country, requestId }) => {
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const authToken = useAuthToken();

    const fetchDetail = useCallback(async () => {
        if (!authToken || !country || !requestId) {
            setData(null);
            return;
        }

        try {
            setLoading(true);
            setError(null);
            const response = await getERPOracleRequestDetail(country, requestId, authToken);
            setData(response);
        } catch (err) {
            console.error("Error fetching oracle request detail:", err);
            setError(err);
        } finally {
            setLoading(false);
        }
    }, [country, requestId, authToken]);

    // Fetch when requestId changes
    useEffect(() => {
        if (requestId) {
            fetchDetail();
        } else {
            setData(null);
            setError(null);
        }
    }, [requestId, fetchDetail]);

    return {
        data,
        loading,
        error,
        refetch: fetchDetail
    };
};
